import React, { memo, useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import Image from 'utils/packages/rnFastImage';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Text from 'design-system/Text';
import { CardView, Spacer, rem } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import IconPlay from 'design-system/icons/IconPlay';
import { SquircleView } from 'react-native-figma-squircle';
import useColors from 'hooks/useColors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { isWeb } from '../../../../constants';
const defaultImageSource = require('../../../../design-system/img/logo-placeholder.png');
const LEFT_SPACING = 16;
const RIGHT_MARGIN = 8;
const MAX_WIDTH = 160;
const getCardWidth = (width) => Math.floor((width - rem(2 * LEFT_SPACING + RIGHT_MARGIN)) / 2);
const LearnVideoCard = ({ title, onPress, thumbnail, grid, lastItem, }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const { width } = useAppFrameDimensions();
    const initialImage = typeof thumbnail === 'number' ? thumbnail : thumbnail ?? defaultImageSource;
    const imageRef = useRef(initialImage);
    const [image, setImage] = useState(initialImage);
    useEffect(() => {
        if (typeof thumbnail !== 'number' &&
            imageRef?.current?.uri !== thumbnail) {
            imageRef.current = { uri: thumbnail ?? undefined };
            setImage({ uri: thumbnail ?? undefined });
        }
        else if (thumbnail &&
            typeof thumbnail === 'number' &&
            thumbnail !== imageRef.current) {
            imageRef.current = thumbnail;
            setImage(thumbnail);
        }
    }, [thumbnail]);
    let cardWidth = Math.min(rem(MAX_WIDTH), getCardWidth(width));
    if (isWeb) {
        cardWidth = width / 3 - ((LEFT_SPACING + RIGHT_MARGIN) * 2) / 3;
    }
    return (<TouchableBounce onPress={onPress} style={[
            styles.touchable,
            { width: cardWidth },
            grid && styles.flexContainer,
            grid && styles.grid,
            lastItem && styles.lastItemTouchable,
        ]}>
      <CardView style={[styles.card, { width: cardWidth }, grid && styles.grid]} noMargin>
        <View style={styles.thumbnailContainer}>
          <IconPlay color={'white'} style={styles.playIcon} width={16} height={16}/>
          <SquircleView style={styles.s100OuterContainer} squircleParams={{
            cornerSmoothing: 1,
            cornerRadius: rem(24),
            fillColor: colors.background.light,
        }}>
            {image !== null && (<Image style={[
                styles.s100,
                styles.whiteBackground,
            ]} source={image}/>)}
          </SquircleView>
        </View>
        <Spacer h={8}/>
        <View style={styles.textContainer}>
          <Text style={styles.title} Text-14 numberOfLines={2}>
            {title}
          </Text>
        </View>
      </CardView>
    </TouchableBounce>);
};
export default memo(LearnVideoCard);
const styleSet = createStyleSheets((colors) => ({
    touchable: {
        marginRight: rem(RIGHT_MARGIN),
        borderRadius: rem(16),
    },
    flexContainer: {
        flex: 1,
        marginVertical: rem(4),
    },
    card: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: rem(8),
        paddingVertical: rem(8),
        backgroundColor: colors.cards.onDark,
    },
    textContainer: {
        paddingVertical: rem(8),
        paddingHorizontal: rem(8),
        width: '100%',
        justifyContent: 'center',
    },
    title: {
        height: rem(44),
    },
    thumbnailContainer: {
        width: '100%',
        position: 'relative',
    },
    playIcon: {
        position: 'absolute',
        zIndex: 100,
        top: '50%',
        left: '50%',
        transform: [{ translateX: -8 }, { translateY: -8 }],
    },
    grid: {
        marginRight: rem(0),
        width: '100%',
    },
    lastItemTouchable: {
        flex: 0,
        width: '50%',
        paddingRight: rem(RIGHT_MARGIN / 2),
    },
    s100OuterContainer: {
        width: '100%',
        aspectRatio: 3 / 4,
        alignItems: 'center',
        justifyContent: 'center',
    },
    s100: {
        width: '100%',
        height: '100%',
        borderRadius: rem(12),
    },
    whiteBackground: {
        backgroundColor: colors.background.logo,
    },
}));
